import React from 'react'
import { useTranslation } from "react-i18next";
import styles from './Terms.module.css'
import { useSelector } from 'react-redux';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';

 function Terms() {

  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const isArabic = currentLanguage === "ar";

  const {conditions, loading } = useSelector((state) => state.usersSlice);

  console.log("conditions",conditions)
  console.log("location",location)
  console.log("location?.state",location?.state)

  let terms;
  if(location?.state){
    if(isArabic){
      terms =conditions?.con_Packages
    }
    else{
      terms =conditions?.con_Packages_en
    }

  }

  else{
    if(isArabic){
      terms =conditions?.con_General
    }
    else{
      terms =conditions?.con_General_en
    }
 

  }

  return (
    <>
          <div className={styles.termsContainer}>
    {loading ?  <div style={{display:"flex", justifyContent:"center"}}>
           
           <Spinner animation="border" role="status" style={{width:"100px", height:"100px"}}/>
          </div> 
          : 
          <div style={{color:"#3D3D3D", fontWeight:"600"}}>
          <div style={{ margin: "20px 0" }}>
          <div style={{ margin: "20px 0" }}>
      {terms?.split("\n").map((line, index) => {
        // إزالة المسافات الزائدة من بداية ونهاية كل سطر
        const trimmedLine = line.trim();
        console.log("trimmedLine",trimmedLine)
    
        // التحقق مما إذا كان السطر عنوانًا رئيسيًا بناءً على نمط يبدأ بكلمة مثل "أولا:" متبوعة بمحتوى
        const isTitle = /^(?:اولا|ثانيا|ثالثا|رابعا|خامسا|سادسا|سابعا|ثامنا|تاسعا|عاشرا|أقرار|شروط|Terms|First|Second|Third|III|Fourth|Fifth|Sixth|VII|Seventh|Eighth|X:|Tenth|Declaration)\s*[:：]?/u.test(trimmedLine);
    
        return (
          <p key={index} style={{ marginBottom: "10px" , fontFamily:"Cairo"}}>
            {isTitle ? <strong>{trimmedLine}</strong> : trimmedLine}
            {/* {trimmedLine} */}
          </p>
        );
      })}
    </div>
         
    
    {location?.state && <div className={styles.onSubmit} onClick={()=>navigate(-1)} >
              { t('back')}
              </div>}
    </div>
    
    
          </div>}
        </div>
    </>
  
  )
}
export default Terms;
